import React from "react";

import Big from "big.js";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { Text } from "components/Text";
import { SplitType } from "constants/splits";
import { formatSplitAmount } from "lib/splits";
import { getBusinessById } from "selectors";

interface SplitAllocationRowProps {
  businessId: string;
  amount: string | number;
  type: SplitType;
  gstOverride?: boolean | null;
}

export const SplitAllocationRow = ({
  businessId,
  amount,
  type,
  gstOverride,
}: SplitAllocationRowProps) => {
  const business = useSelector(getBusinessById(businessId));
  const amountLabel = formatSplitAmount(new Big(amount), type);
  const gstLabel =
    gstOverride === true ? " - GST" : gstOverride === false ? " - No GST" : "";
  return (
    <Grid item xs={6}>
      <Text>
        {business?.name || businessId}: {amountLabel}
        {gstLabel}
      </Text>
    </Grid>
  );
};
